import React, { useEffect, useState } from 'react';
import styles from './MainPage.module.css';
import BalanceTop from '../../components/BalanceTop/BalanceTop';
import { getBoxes } from '../../Requests/boxes/boxes';
import type { Collection } from '../../types/Boxes/boxes';
import boxbg from '../../assets/backgroundBox.jpg';
import Reward from '../../components/Reward/Reward';
import BoxModal from './BoxModal';
import { useModalStore } from '../../store/ModalStore';
import BluePage from '../../components/BluePage/BluePage';
import { useBluePageStore } from '../../store/BluePageStore';
import { motion } from 'framer-motion';
import bluePageImage from '../../assets/mockImg.png';
const MainPage = () => {
  const [collection, setCollection] = useState<Collection[]>([]);
  const [chosenId, setChosenId] = useState<number>();
  const open = useBluePageStore((state) => state.open);
  const setOpen = useModalStore((state) => state.setOpen);
  const [banners, setBanners] = useState<Banner[]>([]);

  useEffect(() => {
    const getBoxesRequest = async () => {
      const response = await getBoxes();
      setCollection(response.collections);
      setBanners(response.banners);
      console.log(response, 'boxes');
    };
    getBoxesRequest();
  }, []);

  const openModal = (id: number) => {
    setOpen(true);
    setChosenId(id);
  };

  return (
    <div className={styles.pageContainer}>
      <BalanceTop />
      <div className={styles.content}>
        <div className={styles.sectionHeader}>BeastGifts</div>

        <div className={styles.bannersWrapper}>
          <motion.div
            className={styles.bannersContainer}
            drag="x"
            dragConstraints={{ left: -600, right: 0 }}
            dragElastic={0.15}
          >
            {banners.map((banner) => (
              <motion.div className={styles.bannerItem}>
                <div className={styles.bannerItemTitle}>{banner.title}</div>
                <button className={styles.bannerItemButton}>Купить</button>
              </motion.div>
            ))}
            {/* <motion.div className={styles.bannerItem}>
              <div className={styles.bannerItemTitle}>
                Summer <br /> Collection
              </div>
              <button className={styles.bannerItemButton}>Купить</button>
            </motion.div>
            <motion.div className={styles.bannerItem}>
              <div className={styles.bannerItemTitle}>
                Winter <br /> Collection
              </div>
              <button className={styles.bannerItemButton}>Купить</button>
            </motion.div>
            <motion.div className={styles.bannerItem}>
              <div className={styles.bannerItemTitle}>
                Spring <br /> Collection
              </div>
              <button className={styles.bannerItemButton}>Купить</button>
            </motion.div> */}
          </motion.div>
        </div>

        <div className={styles.collectionsContainer}>
          {collection.map((collection) => (
            <div key={collection.id} className={styles.collectionItem}>
              <div className={styles.collectionName}>{collection.name}</div>
              <div className={styles.collectionDescription}>
                {collection.description}
              </div>
              <div className={styles.collectionBoxes}>
                {collection.boxes.map((box) => (
                  <div
                    key={box.id}
                    className={styles.collectionBox}
                    onClick={() => openModal(box.id)}
                    style={{ backgroundImage: `url(${boxbg})` }}
                  >
                    <div className={styles.collectionBoxImage}>
                      <img src={bluePageImage} alt="collection image" />
                    </div>
                    <div className={styles.collectionBoxPrice}>
                      <Reward
                        reward={box.price <= 0 ? 'Бесплатно' : box.price}
                        size="large"
                        type="star"
                      />
                    </div>
                    <div className={styles.ribbon}>
                      <span className={styles.ribbonInner}>
                        <span className={styles.ribbonText}>Эксклюзив</span>
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <BoxModal chosenId={chosenId || 0} />
      {open && <BluePage />}
    </div>
  );
};

export default MainPage;
